import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../assets/img/logo/footer-logo.png";
import blogImg1 from "../../assets/img/footer/ft-3.png";
import blogImg2 from "../../assets/img/footer/ft-4.png";
import footerBG from "../../assets/img/footer/footer-bg.jpg";

const FooterTwo = (props) => {
  const { footerLogo, footerClass } = props;
  return (
    <footer>
      <div
        className={footerClass ? footerClass : "footer-3__area footer-3__plr"}
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-3__widget footer-3__widget-box footer-2-col-1">
                <div className="footer-3__logo">
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        background: "#FFDC60",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "800",
                        color: "#232323",
                        border: "2px solid white",
                      }}
                    >
                      AM
                    </div>
                    <span
                      style={{
                        fontSize: "1.6rem",
                        fontWeight: "700",
                        color: "white",
                      }}
                    >
                      Ayush Mishra
                    </span>
                  </Link>
                </div>
                <div className="footer-3__content">
                  <div className="footer-3__text">
                    <p>
                      Specializing in React & React Native business
                      applications. I help companies streamline operations with
                      custom inventory management, employee tracking, and
                      analytics solutions.
                    </p>
                  </div>
                  <div className="footer-3__social-box">
                    <a
                      href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a
                      href="https://github.com/IMshadow8802"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-github"></i>
                    </a>
                    <a href="mailto:ayushmishra7352@gmail.com">
                      <i className="far fa-envelope"></i>
                    </a>
                    <a href="tel:+918802487352">
                      <i className="fas fa-phone"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-3__widget footer-3-col-2">
                <h4 className="footer-3__title">
                  <span>Quick Links</span>
                </h4>
                <div className="footer-3__menu-list">
                  <ul>
                    <li>
                      <Link to="/">
                        <i className="fal fa-angle-right"></i>Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about">
                        <i className="fal fa-angle-right"></i>About Me
                      </Link>
                    </li>
                    <li>
                      <Link to="/projects">
                        <i className="fal fa-angle-right"></i>My Projects
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact">
                        <i className="fal fa-angle-right"></i>Contact
                      </Link>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fal fa-angle-right"></i>LinkedIn
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://github.com/IMshadow8802"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fal fa-angle-right"></i>GitHub
                      </a>
                    </li>
                    <li>
                      <a href="mailto:ayushmishra7352@gmail.com">
                        <i className="fal fa-angle-right"></i>Email Me
                      </a>
                    </li>
                    <li>
                      <a href="tel:+918802487352">
                        <i className="fal fa-angle-right"></i>Call Me
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-3__widget footer-3-col-3">
                <h4 className="footer-3__title">
                  <span>My Services</span>
                </h4>
                <div className="footer-3__services-list">
                  <div style={{ color: "white" }}>
                    <div
                      style={{
                        marginBottom: "15px",
                        paddingBottom: "10px",
                        borderBottom: "1px solid rgba(255,255,255,0.1)",
                      }}
                    >
                      <h5
                        style={{
                          color: "#FFDC60",
                          fontSize: "14px",
                          marginBottom: "5px",
                        }}
                      >
                        Inventory Management Systems
                      </h5>
                      <p
                        style={{ fontSize: "12px", color: "#ccc", margin: "0" }}
                      >
                        Custom solutions for retail businesses
                      </p>
                    </div>
                    <div
                      style={{
                        marginBottom: "15px",
                        paddingBottom: "10px",
                        borderBottom: "1px solid rgba(255,255,255,0.1)",
                      }}
                    >
                      <h5
                        style={{
                          color: "#FFDC60",
                          fontSize: "14px",
                          marginBottom: "5px",
                        }}
                      >
                        Employee Management Apps
                      </h5>
                      <p
                        style={{ fontSize: "12px", color: "#ccc", margin: "0" }}
                      >
                        Attendance tracking & workforce solutions
                      </p>
                    </div>
                    <div>
                      <h5
                        style={{
                          color: "#FFDC60",
                          fontSize: "14px",
                          marginBottom: "5px",
                        }}
                      >
                        Business Analytics
                      </h5>
                      <p
                        style={{ fontSize: "12px", color: "#ccc", margin: "0" }}
                      >
                        Real-time dashboards & reporting
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-3__widget footer-3-col-4">
                <h4 className="footer-3__title">
                  <span>Get In Touch</span>
                </h4>
                <div className="footer-3__content">
                  <div className="footer-3__text-2">
                    <p>
                      Ready to transform your business operations? Let's discuss
                      your project and create a solution that drives real
                      results.
                    </p>
                  </div>

                  {/* Contact Info */}
                  <div
                    className="footer-3__contact-info"
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <i
                        className="far fa-envelope"
                        style={{ color: "#FFDC60", fontSize: "14px" }}
                      ></i>
                      <a
                        href="mailto:ayushmishra7352@gmail.com"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          fontSize: "14px",
                        }}
                      >
                        ayushmishra7352@gmail.com
                      </a>
                    </div>
                    <div
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <i
                        className="fas fa-phone"
                        style={{ color: "#FFDC60", fontSize: "14px" }}
                      ></i>
                      <a
                        href="tel:+918802487352"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          fontSize: "14px",
                        }}
                      >
                        +91 8802487352
                      </a>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <i
                        className="fas fa-map-marker-alt"
                        style={{ color: "#FFDC60", fontSize: "14px" }}
                      ></i>
                      <span style={{ color: "white", fontSize: "14px" }}>
                        Delhi, India
                      </span>
                    </div>
                  </div>

                  {/* Response Time */}
                  <div
                    style={{
                      background: "rgba(255, 220, 96, 0.1)",
                      border: "1px solid #FFDC60",
                      borderRadius: "8px",
                      padding: "15px",
                      textAlign: "center",
                    }}
                  >
                    <h6
                      style={{
                        color: "#FFDC60",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      ⚡ Quick Response Guaranteed
                    </h6>
                    <p
                      style={{ fontSize: "12px", margin: "0", color: "white" }}
                    >
                      I respond within 2-4 hours during business hours
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright__area copyright__border pt-25 pb-25">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div
                  className="col-md-12 wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <div className="copyright__text text-center">
                    <span>© 2025 Ayush Mishra. All Rights Reserved.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
